import React, { createContext, useState, useContext, useEffect } from "react";
import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // Will store { username, passcode }
  const [loading, setLoading] = useState(true); // Check initial auth state

  // Check localStorage on initial load
  useEffect(() => {
    const storedUser = localStorage.getItem("authUser");
    if (storedUser) {
      try {
        setUser(JSON.parse(storedUser));
      } catch (e) {
        console.error("Failed to parse stored user", e);
        localStorage.removeItem("authUser");
      }
    }
    setLoading(false);
  }, []);

  const login = async (username, passcode) => {
    try {
      // Call existing verifyCredentials cloud function to check username/passcode
      const verifyCredentials = httpsCallable(functions, "verifyCredentials");
      const result = await verifyCredentials({ username, passcode });

      if (result.data.success) {
        const userData = { username, passcode }; // Store credentials for future API calls
        setUser(userData);
        localStorage.setItem("authUser", JSON.stringify(userData)); // Store credentials
        return true;
      } else {
        throw new Error(result.data.message || "Invalid credentials");
      }
    } catch (error) {
      console.error("Login error:", error);
      setUser(null);
      localStorage.removeItem("authUser");
      throw error;
    }
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem("authUser");
  };

  // Always provide context value, even during loading
  return (
    <AuthContext.Provider
      value={{ user, login, logout, isAuthenticated: !!user, loading }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
